import React from 'react';
import Text from '../../../common/component/Text';
import KakaopageContentCard from '../../../commonSub/component/KakaopageContentCard';
import {IOriginalProduct} from '../../../commonSub/type';
import {WEBTOON_RELATED_NOVEL_LABEL} from '../../../content/common';

interface IProps {
  originalProduct: IOriginalProduct;
  episodeId: number;
}

export default function OriginalProduct({originalProduct, episodeId}: IProps) {
  return (
    <>
      <div className="mt-30 lg:ml-0">
        <Text className="mb-12 ml-10 s16-bold-white leading-18 light:text-black">
          {WEBTOON_RELATED_NOVEL_LABEL}
        </Text>
        <KakaopageContentCard
          originalNovel={originalProduct.originalNovel}
          sizeClassName="h-[230px] w-[115px] lg:h-[236px] lg:w-[118px]"
          referrerId={episodeId}
          isViewer={true}
        />
      </div>
    </>
  );
}
